import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/frontru/nesterenko/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/components/ui/container/index.module.scss");
;
import(/* webpackMode: "eager" */ "/home/frontru/nesterenko/src/views/policy/index.module.scss");
